import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGetExamTokenAction } from '@/Module/Auth/Store/Action';
import type { IExamAuth } from '@/Module/Exam/Model/ApiModel';
import type { IExam } from '@/Module/Exam/Model/DataModel';
import { ExamCookieService, ExamService } from '@/Module/Exam/Service';

export const getExamByContentIdAction = createAsyncThunk<IExam, string>(
  'exam/getByContentId',
  async (id, { dispatch, signal }) => {
    let examAccessToken = ExamCookieService.getAccessToken();
    if (!examAccessToken)
      await dispatch(authGetExamTokenAction())
        .unwrap()
        .then((accessToken: IExamAuth) => {
          if (accessToken.accessToken) {
            ExamCookieService.setAccessToken(accessToken.accessToken);
          }
        });

    examAccessToken = ExamCookieService.getAccessToken();
    return ExamService.getExamByContentId(id, examAccessToken, { disabledAutoError: true }, signal).then(({ data }) => data);
  },
);
